import { Col, Row, Layout, Input, Select, DatePicker, Tabs, Button } from 'antd'
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react'
import DriverPaymentsTab from './DriverPaymentsTab';
import helper from '../../helper';
// import helper from 't18helper/dist/fetchHelper';


const { TabPane } = Tabs;

var box = {
    minHeight: 100,
    backgroundColor: "white",
    margin: 10,
    padding: 30,
    borderRadius: 10
};
const { Option } = Select;

const DriverPayments = observer(({ props }) => {
    return (
        <>
            <Row gutter={[8, 8]} style={{ width: '100%' }}>
                <Col span={24}>
                    <div style={box}>
                        <div style={{ height: 50, width: '100%' }}>
                            <Button onClick={async () => {
                                // alert('hello')
                                var res = await helper.createData({}, 'calculatePayments')
                                if (res.status === 200) {
                                    window.location.reload();

                                }

                            }} style={{ float: 'right' }}>Generate Payments</Button>
                        </div>
                        <Tabs defaultActiveKey="1"  >
                            <TabPane tab="Paynents" key="1"> <DriverPaymentsTab /></TabPane>
                        </Tabs>
                    </div>
                </Col>

            </Row>
        </>
    );
});
export default DriverPayments;